import { cva } from "class-variance-authority"

// SCSS-based progress variants using WeLoop design system classes
export const progressVariants = cva(
  "wl-progress", // Base WeLoop progress class
  {
    variants: {
      variant: {
        default: "", // Default variant uses base wl-progress class
        fail: "wl-progress-fail",
        complete: "wl-progress-complete",
        indicator: "wl-progress-indicator",
        pie: "wl-progress-pie",
      },
      size: {
        default: "", // Default size is handled by wl-progress
        sm: "wl-progress-sm",
      },
      position: {
        default: "", // Default position
        end: "wl-progress-end",
      },
      percentageDisplay: {
        none: "", // No percentage display
        preview: "wl-progress-preview", // Hover to show percentage
        badge: "wl-progress-badge", // Always visible badge
        tooltip: "wl-progress-tooltip", // Hover tooltip above
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      position: "default",
      percentageDisplay: "none",
    },
  }
) 